import { EventEmitter } from '@angular/core';

/**
 * Base filter bar component to get the filter value
 */
export abstract class FilterCompositeComponent {

  abstract id: string;
  abstract label(): string;
  abstract criteria(): string;
  abstract clear(): void;

  /** Emitted by the component itself when its own inline submit/clear control is used. */
  applied = new EventEmitter<void>();
}
